import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import "./Home.css";

function Home() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            entry.target.classList.remove("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    const sections = document.querySelectorAll(".info-section, .cta-section");
    sections.forEach((sec) => observer.observe(sec));

    return () => observer.disconnect();
  }, []);

  const sections = [
    {
      title: "Greenview San Diego Hardscape | Licensed C-27 Landscape Contractor",
      text:
        "Greenview San Diego Hardscape is a California licensed C-27 Landscape Contractor (CSLB License #1141945). Serving San Diego County, we specialize in professional hardscape, concrete, pavers, and outdoor landscape construction for residential properties.",
    },
    {
      title: "C-27 Landscape Construction Services",
      text:
        "As a licensed C-27 Landscaping Contractor, we are authorized to perform landscape construction including grading, drainage, concrete flatwork, pavers, retaining walls, and outdoor structural improvements — all completed according to California building codes.",
    },
    {
      title: "Hardscape, Concrete & Outdoor Design",
      text:
        "We help homeowners upgrade their outdoor spaces with clean, durable, and functional designs. From patios and walkways to full backyard renovations, our team focuses on quality workmanship, long-term durability, and professional project management.",
    },
    {
      title: "Why Hire a Licensed C-27 Contractor?",
      text:
        "Hiring a CSLB licensed contractor protects homeowners through written contracts, proper insurance, and code-compliant construction. Greenview San Diego Hardscape operates legally under CSLB License #1141945 and delivers professional results you can trust.",
    },
    {
      title: "Greenview San Diego Hardscape — Contact & Appointments",
      text: (
        <>
          All site visits and estimates are available by <strong>appointment only</strong>.
          <br />
          <br />
          <strong>Business Name:</strong> Greenview San Diego Hardscape
          <br />
          <strong>CSLB License:</strong> 1141945 — C-27 Landscape Contractor
          <br />
          <strong>Phone (Call/Text):</strong>{" "}
          <a href="tel:+16194649153">(619) 464-9153</a>
          <br />
          <strong>Location:</strong> La Mesa, California
        </>
      ),
    },
  ];

  return (
    <div className="home-container">
      <Helmet>
        <title>
          Greenview San Diego Hardscape | Licensed C-27 Landscape Contractor
        </title>
        <meta
          name="description"
          content="Greenview San Diego Hardscape is a licensed C-27 Landscape Contractor (CSLB #1141945) serving San Diego County. Specializing in hardscape, concrete, pavers, and outdoor landscape construction. Estimates available by appointment."
        />
      </Helmet>

      {/* Hero Section */}
      <section className="hero-section">
        <video
          className="hero-video"
          autoPlay
          loop
          muted
          playsInline
          poster="/logo512.png"
        >
          <source src="/banner.mp4" type="video/mp4" />
          Your browser doesn’t support HTML5 video.
        </video>

        <div className="hero-overlay animate-fadeInUp">
          <div className="overlay-content">
            <h1>{sections[0].title}</h1>
            <p>{sections[0].text}</p>
          </div>
        </div>
      </section>

      {/* Info Sections */}
      {sections.slice(1, 4).map((section, idx) => (
        <section key={idx} className="info-section animate-fadeInUp">
          <div className="info-box">
            <h2>{section.title}</h2>
            <p>{section.text}</p>
          </div>
        </section>
      ))}

      {/* CTA Section */}
      <section className="cta-section animate-fadeInUp">
        <h2>{sections[4].title}</h2>
        <div className="cta-text">{sections[4].text}</div>

        <div className="cta-buttons" style={{ marginTop: "1rem" }}>
          <a className="btn btn-primary" href="tel:+16194649153">
            Call or Text
          </a>
        </div>
      </section>
    </div>
  );
}

export default Home;